import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../api/auth.service';
import { catchError, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  let authRequest = req;

  if (
    req.url.endsWith('/auth/login') ||
    req.url.endsWith('/auth/refresh') ||
    req.url.endsWith('/auth/logout') ||
    req.url.endsWith('/auth/anonymous') ||
    req.url.includes('/auth/internal-login')
  ) {
    return next(req);
  }

  if (token) {
    authRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(authRequest).pipe(
    catchError((error) => {
      if (error.status === HttpStatusCode.Unauthorized && !req.url.endsWith('/auth/refresh')) {
        return authService.refresh().pipe(
          switchMap((res) => {
            const newReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${res.accessToken}`,
              },
            });

            return next(newReq);
          }),
          catchError(() => {
            authService.clear();
            router.navigate(['/login']);
            return throwError(() => error);
          }),
        );
      }

      return throwError(() => error);
    }),
  );
};
